<template>
  <div>
    <div class="d-flex flex-row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <v-btn
          class="mx-4 mb-6"
          color="primary"
          @click.stop="
            dialogEditTheme = true;
            themeEditing = {};
            isRootTheme = true;
          "
          >Créer un thème
        </v-btn>

        <!-- <v-treeview
          :active="themeSelected"
          :items="themes"
          activatable
          return-object
          open-all
          item-text="title"
          @update:active="selection"
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? "mdi-folder-open" : "mdi-folder" }}
            </v-icon>
            <v-icon v-else>
              {{ files[item.file] }}
            </v-icon>
          </template>
        </v-treeview> -->

        <VuetifyDraggableTreeview
          v-model="themes"
          :items="themes"
          update:active="updateActive"
          activatable
          return-object
          v-on:input="dragTheme"
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? "mdi-folder-open" : "mdi-folder" }}
            </v-icon>
            <v-icon v-else>
              {{ files[item.file] }}
            </v-icon>
          </template>

          <template v-slot:label="{ item }">
            <span class="primary--text pl-2" @mousedown="selection(item)">
              {{ item.title }}
            </span>
          </template>

          <template v-slot:append="{ item }">
            <!-- <template v-if="item.children != null && item.children.length > 0">
              {{ item.children.length }} sous-dossier(s)
            </template> -->

            <!-- Ajout d'un theme -->
            <!-- <v-icon class="pl-2" small @click.stop="dialog = true">mdi-plus-circle</v-icon> -->

            <!-- modification / supression utilisateur -->
            <v-icon class="pl-2" small @click="deleteTheme(item)">mdi-delete</v-icon>
          </template>

        </VuetifyDraggableTreeview>
      </div>
      <v-divider vertical></v-divider>
      <div class="px-6 col-lg-8 col-md-8 col-sm-12">
        <template v-if="themeSelected === null">
          Aucun thème sélectionné
        </template>
        <template v-else>
          <div>
            <h3 class="text-center mb-4">
              Thème sélectionné : {{ themeSelected.title }}
            </h3>
            
            <div v-if="themeSelected !== null && !themeSelected.parent" class="text-center">
            <div class="text-center">
              <v-btn depressed color="primary" v-on:click="inputLogoClick">
                Modifier le logo
              </v-btn>
            </div>
              <v-avatar rounded style="border: 1px solid black !important;margin:15px" color="white" size="100">
                <v-img contain :src="getSelectedThemeLogo" />
              </v-avatar>
              <input id="logoInput" hidden type="file" @change="getUploadedFile" ref="file">
            </div>

            <div class="mb-5 text-center">

              <v-btn depressed color="primary" @click.stop="showEditThemeDialog">
                Modifier le thème
              </v-btn>
              <v-btn class="ml-4" :disabled="isDisabled" color="primary" @click.stop="dialogEditTheme = true; themeEditing = {}; isRootTheme = false;">
                Ajouter un sous-thème
              </v-btn>
              <v-btn class="ml-4" color="primary" @click.stop="showUserRightDialog">
                {{ themeSelected.userRights && themeSelected.userRights.length > 0 ? "Modifier le droit utilisateur" : "Ajouter un droit utilisateur" }}
              </v-btn>
              <!-- <ThemeTreeviewUserRightTable
              v-model="theme"
              @updateUserRightTheme="updateUserRightTheme"
              ></ThemeTreeviewUserRightTable> -->
              <!-- <div class="col-xl-3 text-end pb-0">
                <a class="btn btn-light-danger" color="primary" @click.stop="dialog = true">
                  {{ !!userRightSelected && userRightSelected.length > 0 ? "Modifier le droit utilisateur" : "Ajouter un droit utilisateur" }}
                </a>
              </div> -->
              <v-btn class="ml-4" fab small dark color="pink lighten-2" @click="deleteTheme()">
                <v-icon dark> mdi-delete </v-icon>
              </v-btn>
            </div>

            <p v-if="isDisabled === true">
              Vous ne pouvez pas ajouter un sous-thème à un thème qui contient
              déjà des vidéos
            </p>

            <div class="row">
              <div class="col-xl-12 py-0">
              <div class="form-group">
                <v-simple-table class="elevation-0">
                  <template v-slot:default>
                    <thead>
                      <tr class="pt-0">
                        <th class="text-left pl-4">Nom des droits utilisateurs sélectionnés</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="userRight in themeSelected.userRights" :key="userRight.id">
                        <td>
                          <div class="d-flex justify-content-between align-items-center">
                            <div class="py-2 pl-4">{{ userRight.name }}</div>
                          </div>
                          <v-divider class="my-0"></v-divider>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
              </div>
            </div>

            <v-expansion-panels v-if="typeof themeSelected.children === 'undefined' || themeSelected.children.length === 0">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>
                    Vidéos contenus dans le thème ({{
                      themeSelected.videos.length
                    }}) :
                  </h5>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="themeSelected.videos">
           <!-- <v-expansion-panel-content v-if="themeSelected.videos.length > 0"> -->
                  <div class="v-cards-theme">
                    <v-card
                      v-for="video in themeSelected.videos"
                      :key="video.id"
                      class="mx-auto"
                      outlined
                    >
                      <router-link
                        :to="{
                          name: 'modifierVideo',
                          params: {
                            id: video['@id'].substring(12),
                          },
                        }"
                      >
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div
                                  class="overline mb-2 text-truncate"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  {{ video.title }}
                                </div>
                              </template>
                              <span>{{ video.title }}</span>
                            </v-tooltip>

                            <v-list-item-subtitle>
                              Créée le
                              {{
                                video.createdAt | moment
                              }}</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-list-item-avatar tile size="50" color="grey"
                            ><v-img
                              :src="
                                apiUrl +
                                '/files/uploads/video/posterFile/' +
                                video.poster
                              "
                            >
                            </v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                      </router-link>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>
                  <p>Aucune vidéo à afficher</p>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h5>Parcours contenus dans le thème ({{ themeSelected.courses.length}}) :</h5>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="themeSelected.courses.length > 0">
                  <div class="v-cards-theme">
                    <v-card v-for="course in themeSelected.courses" :key="course.id" class="mx-auto" outlined>
                      <router-link
                        :to="{ name: 'modifierParcours', params: { id: course['@id'].substring(13)} }"
                      >
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="overline mb-2" v-bind="attrs" v-on="on">
                                  {{ course.title }}
                                </div>
                              </template>
                              <span>{{ course.title }}</span>
                            </v-tooltip>
                            <v-list-item-subtitle >Crée le {{ course.createdAt | moment}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar tile size="50" color="grey"><v-img :src=" apiUrl + '/files/uploads/course/posterFile/' + course.poster "></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                      </router-link>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>
                  <p>Aucun parcours à afficher</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </template>
      </div>
    </div>

    <DialogEditTheme
      :isVisible="dialogEditTheme"
      v-model="themeEditing"
      @submit="submitTheme"
      @cancel="
        dialogEditTheme = false;
        themeEditing = null;
      "
    ></DialogEditTheme>

    <!-- Modal pour choisir le thème  -->
    <v-dialog v-model="dialogUserRight" v-if="themeSelected !== null" max-width="700">
      <v-card max-width="700">
        <v-card-title class="headline d-flex justify-content-center px-1">Veuillez sélectionner un/des droit.s utilisateur.s</v-card-title>
          <v-card-text>
            <v-treeview
              v-model="userRightSelected"
              :items="userRights"
              item-value="name"
              item-text="name"
              selectable
              background-color="#f5b83e"
              return-object
            ></v-treeview>
          </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" text @click="dialogUserRight = false">Annuler</v-btn>
          <v-btn color="blue darken-1" text @click="saveUserRights"> Valider la sélection </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";
import DialogEditTheme from "@/components/admin/theme/dialogs/editTheme";
import VuetifyDraggableTreeview from "vuetify-draggable-treeview";
import userParentThemes from "@/core/utils/userParentThemes";
import {getThemeLogoUrl} from '@/core/utils/theme';
import { mapGetters } from "vuex";
//import ThemeTreeviewUserRightTable from "@/components/admin/userRight/forms/tabs/themeTreeviewUserRightTable.vue";


/**
 * Rechercher de manière récursive un thème dans une liste de thèmes et dans les thèmes enfants
 * @param themes Liste de thèmes
 * @param id Identifiant du thème recherché
 * @returns {number|*|number} Index du thème trouvé ou -1 si thème introuvable
 */
function searchThemeIndex(themes, id) {
  let index = themes.findIndex(t => t.id === id);

  // Le thème est trouvé -> on retourne son index
  if (index >= 0) {
    return index;
  } else {
    // On recherche dans l'ensemble des thèmes enfants
    for (const theme of themes) {
      if (theme.children) {
        index = searchThemeIndex(theme.children, id);
        if (index >= 0) {
          return index;
        }
      }
    }
  }

  return -1;
}

export default {
  name: "themes",
  data: () => ({
    dialog: false,
    dialogUserRight: false,
    themes: [],
    themeSelected: null,
    themeLogo:null,
    isDisabled: null,
    isRootTheme: true,
    dialogEditTheme: false,
    themeEditing: null,
    themeEditingParent: null,
    userRights: [],
    userRightSelected: null,

  }),
  model: {
    prop: "theme",
    event: "input",
  },
  props: {
    theme: Object,
  },
  components: {
    DialogEditTheme,
    VuetifyDraggableTreeview,
    //ThemeTreeviewUserRightTable,
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YY");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    defaultLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.nologo");
    },
    apiUrl() {
      return process.env.VUE_APP_API;
    },
    getSelectedThemeLogo: function() {
      return getThemeLogoUrl(this.themeSelected, this.defaultLogo);
    },
  },
  methods: {
    inputLogoClick(){
      var input = document.getElementById('logoInput');
      input.click();
    },
    getUploadedFile() {
      this.themeLogo = this.$refs.file.files[0];
      if(this.themeLogo != null){
        const formData = new FormData();
        formData.append('logo', this.themeLogo);
        Api.post(`themes/${this.themeSelected.id}/media`, formData).then(response => {
          this.themeSelected = response.data;
          this.getAllThemes();
          Swal.fire({
            title: "",
            text: `Le logo a été modifié avec succès.`,
            icon: "success",
          });
        }).catch (error => {
          let errorMessage = "Une erreur est survenue lors de la modification du logo.";

          if (error.response && error.response.data) {
            if (error.response.data["hydra:description"]) {
              errorMessage = error.response.data["hydra:description"];
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          }

          Swal.fire({
            title: "Erreur",
            text: errorMessage,
            icon: "error",
          });
        });
      }
    },
    updateActive(themes) {
      this.themeSelected = themes[0];
    },
    showUserRightDialog() {
      this.userRightSelected = this.themeSelected.userRights || [];
      this.dialogUserRight = true;
    },
    saveUserRights() {
      Api.patch('themes', this.themeSelected.id, {userRights: this.userRightSelected.map(ur => ur['@id'])})
      .then(response => {
        this.themeSelected = response.data;
        this.dialogUserRight = false;
        this.getAllThemes();
      });
    },
    getAllDescendants(theme,childrens = []){
      if(theme.children){
        theme.children.forEach(children =>{
            childrens.push(children.id);
            childrens.concat(this.getAllDescendants(children,childrens));
        });
      }
      return childrens;
    },

    selection(chosenTheme) {
      if (!Array.isArray(chosenTheme)) {
        this.themeSelected = chosenTheme;
        //console.log(this.getAllDescendants(this.themeSelected));
        if (chosenTheme && chosenTheme.videos && chosenTheme.videos.length > 0) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }

    },


    handleRefreshTheme() {
      this.dialogCreateTheme = false;
      this.dialogEditTheme = false;
      this.isRootTheme = true;
      this.themeEditing = null;
      this.getAllThemes();
    },

    getAllThemes() {
      //On récupère tout les thèmes de l'API, et on les mets dans le tableau vide themes (dans data)
      Api.get("themes").then(themes => (this.themes = userParentThemes(themes.data["hydra:member"])));
    },

    submitTheme: async function () {
      if (this.themeEditing["@id"]) {
        this.editTheme();
      } else {
        this.createTheme();
      }
    },
    createTheme: async function () {
      try {
        console.log(this.themeSelected)
        // On extrait les propriétés qu'on veut mettre à jour
        const { title, titleEN } = this.themeEditing;

        const response = await Api.post(`themes`, {
          title: title,
          parent: this.isRootTheme ? null : this.themeSelected["@id"],
          logo: this.isRootTheme ? null : this.themeSelected["logo"],
          logoPath: this.isRootTheme ? null : this.themeSelected["logoPath"],
          //userRights: this.userRights.map(u=>u["@id"]=== this.userRightSelected.name)
        }, { headers: { 'Accept-Language': 'fr_FR' } });
        await Api.patch('themes', response.data.id, { title: titleEN }, { headers: { 'Accept-Language': 'en_GB' } });

        this.handleRefreshTheme();

        Swal.fire({
          title: "",
          text: `Le thème a été créé.`,
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
      } catch (error) {
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la création du thème",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
    },
    async showEditThemeDialog() {
      const responseFR = await Api.get('themes', this.themeSelected.id, { headers: { 'Accept-Language': 'fr_FR' } });
      const responseEN = await Api.get('themes', this.themeSelected.id, { headers: { 'Accept-Language': 'en_GB' } });
      this.themeEditing = {
        ...this.themeSelected,
        title: responseFR.data.title,
        titleEN: responseEN.data.title
      };
      this.dialogEditTheme = true;
    },
    editTheme: async function () {
      try {
        // On extrait les propriétés qu'on veut mettre à jour
        const { title, titleEN } = this.themeEditing;

        const response = await Api.patch('themes', this.themeEditing.id, { title: title }, { headers: { 'Accept-Language': 'fr_FR' } });
        await Api.patch('themes', response.data.id, { title: titleEN }, { headers: { 'Accept-Language': 'en_GB' } });

        this.themeSelected = this.themeEditing;
        this.handleRefreshTheme();

        Swal.fire({
          title: "",
          text: `Le thème a été modifié.`,
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
      } catch (error) {
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la modification du thème",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
    },

    deleteTheme(theme = null) {
      let themeToDelete = theme || this.themeSelected;
      if (!themeToDelete) {
        return;
      }

      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce thème ?",
        text:
          "Attention, cette action est irréversible ! Vous allez également supprimer les parcours (ainsi que leurs vidéos respectives) et les vidéos contenues dans ce thème.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText:
          "Oui, supprimer le thème (avec ses parcours et vidéos)",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.delete("themes/" + themeToDelete.id).then(() => {
            Swal.fire("Supprimé !", "Votre thème a été supprimé", "success");
            this.themeSelected = null;
            this.getAllThemes();
          });
        }
      });
    },

    dragTheme() {
      // Récupérer position apres move
      const position = searchThemeIndex(this.themes, this.themeSelected.id);

      // mise à jour en base donnée de la position
      if (position !== null) {
        Api.patch("themes", this.themeSelected.id, {
          position: position,
        });
      }
    },

    updateThemeUserRight(userRights) {
      // TODO: Vérifier si le droit utilisateur n'est pas déjà présent dans le parcours avant de l'ajouter et afficher message à l'utilisateur
      this.theme.userRights = userRights;
      this.dialogUserRight = false;
    },
    getAllUserRights(){
      Api.get('user_rights').then(u => {
        this.userRights = u.data['hydra:member'];
      })
    },
    // submit: async function() {
          
    //   try {
    //     await Api.post("themes", {
    //       title: this.title,
    //       userRights: this.themeSelected.userRightSelected.map(u=>u['@id'] === u.name)
    //     });
    //     console.log()
    //      Swal.fire({
    //       title: "",
    //       text: "Le droit utilisateur a été crée.",
    //       icon: "success",
    //       confirmButtonClass: "btn btn-secondary",
    //     });
    //     this.$router.push({ name: 'gestionClients', query: {
    //               selected: 'tab-themes',
    //             },})
    //   } catch (error) {
    //     //Dans le cas où la requête a échoué.
    //     Swal.fire({
    //       title: "",
    //       text: "Une erreur est survenue lors de la création du droit utilisateur",
    //       icon: "error",
    //       confirmButtonClass: "btn btn-secondary",
    //     });
    //     return;
    //   }

    // },
  },

  mounted() {
    //this.userRightSelected = this.theme.userRights;
    this.getAllThemes();
    this.getAllUserRights();
  },
};
</script>
